import { observer } from "mobx-react-lite";
import { useState, useCallback, useEffect } from "react";
import { LoadingEllipsis } from "../../shared/components/loading/Loading";
import { useAppContext } from "../../shared/functions/Context";
import useTitle from "../../shared/hooks/useTitle";
import EmptyError from "../admin-settings/EmptyError";
import FYPlan from "./FYPlan";
import "./StrategyThemes.scss";
import useBackButton from "../../shared/hooks/useBack";
import ErrorBoundary from "../../shared/components/error-boundary/ErrorBoundary";

const StrategyThemes = observer(() => {
  const { api, store, ui } = useAppContext();
  const [loading, setLoading] = useState(false);
  useTitle("Strategic Themes");
  useBackButton();

  // load scorecard batch from db
  const loadAll = useCallback(async () => {
    setLoading(true); // start loading
    try {
      await api.scorecard.getAll();
    } catch (error) {
      ui.snackbar.load({
        id: Date.now(),
        message:
          "Error! Failed to load.",
        type: "danger",
      });
    }
    setLoading(false); // stop loading
  }, [api.scorecard, ui.snackbar]);

  useEffect(() => {
    loadAll();
  }, [loadAll]);

  return (
    <ErrorBoundary>
      <div className="strategy-theme-page uk-section uk-section-small">
        <div className="uk-container uk-container-xlarge">
          {!loading &&
            store.scorecard.all.map((batch) => (
              <div key={batch.asJson.id} className="uk-margin">
                <FYPlan scorecardBatch={batch.asJson} />
              </div>
            ))}

          {/* Empty & not loading */}
          {!store.scorecard.all.length && !loading && (
            <EmptyError errorMessage="No scorecard found" />
          )}

          {/* Loading */}
          {loading && <LoadingEllipsis />}
        </div>
      </div>
    </ErrorBoundary>
  );
});

export default StrategyThemes;
